import { BergIcon, BergWeatherTiles } from "@berg-regions/berg-components";
import { useMemo } from "react";
import getIcon from "./getIcon";
import moment from "moment";
import { useSkiInfrastructureStatistics } from "../../lib/hook/useSkiInfrastructureStatistics";
import { useWeather } from "../../lib/hook/useWeather";
import "./WeatherTile.scss";

const WeatherTileComponent = () => {
  const { skiInfrastructureStatistics } = useSkiInfrastructureStatistics();
  const { weather } = useWeather();

  const iconWeather = getIcon(weather?.weatherCode);
  const format = "hh:mm";

  const timeOfDay = useMemo(
    () =>
      moment(weather?.localTime, format).isBetween(
        moment(weather?.sunrise, format),
        moment(weather?.sunset, format)
      )
        ? "day"
        : "night",
    [weather?.localTime, weather?.sunrise, weather?.sunset]
  );

  const firstTileProps = {
    top: weather?.localTime ? weather?.localTime : "---",
    middle: <img src={require(`./icons/${timeOfDay}/${iconWeather}`)} alt="" />,
    bottom:
      weather?.temperature !== undefined ? (
        <div className="flex">
          <span className="first">{weather?.temperature}</span>
          <span className="second">&#x2009;&#x2103;</span>
        </div>
      ) : null,
    weather: true,
  };
  const secondTileProps = {
    top: <BergIcon name="ski_lift_person_white" />,
    middle: "Otwarte wyciągi",
    bottom:
      skiInfrastructureStatistics?.openLifts !== undefined ? (
        <span
          className="first [counter-set:_num_var(--num)] before:content-[counter(num)]"
          style={
            skiInfrastructureStatistics.openLifts !== undefined
              ? {
                  animation: `counter${skiInfrastructureStatistics?.openLifts} 2s ease-out forwards`,
                }
              : {}
          }
        >
          {"/"}
          {skiInfrastructureStatistics.totalLifts}
        </span>
      ) : null,
  };

  const thirdTileProps = {
    top: <BergIcon name="road_white" />,
    middle: "Otwarte trasy",
    bottom:
      skiInfrastructureStatistics?.openRuns !== undefined ? (
        <span
          className="first [counter-set:_num_var(--num)] before:content-[counter(num)]"
          style={{
            animation: `counter${skiInfrastructureStatistics.openRuns} 2s ease-out forwards`,
          }}
        >
          {"/"}
          {skiInfrastructureStatistics.totalRuns}
        </span>
      ) : null,
  };

  const fourthTileProps = {
    top: "Kamery",
    middle: <BergIcon name="webCam" />,
    bottom: (
      <>
        "Ogladaj na zywo" <BergIcon name="click" />
      </>
    ),
  };
  return (
    <BergWeatherTiles
      firstTileProps={firstTileProps}
      secondTileProps={secondTileProps}
      thirdTileProps={thirdTileProps}
      fourthTileProps={fourthTileProps}
      className={"slide-in-bottom berg-led"}
    />
  );
};

export default WeatherTileComponent;
